import IRole from '@/interfaces/IRole'

export default class OrganizationalRole implements IRole {
  public id: string = ''
  public name: string = ''

  constructor(id: string = '', name: string = '') {
    this.id = id
    this.name = name
  }
}
